import kotlinx.coroutines.flow.StateFlow
import models.PublicGameSummary

/** UI-independent start-screen state shared by SwiftUI and Compose. */
data class BankoStartScreenUiState(
    val userNameFlow: StateFlow<String>,
    val gameCodeFlow: StateFlow<String>,
    val joinedGameCodeFlow: StateFlow<String>,
    val errorMessageFlow: EventStateFlow<String>,
    val joinedGameIsValidFlow: EventStateFlow<Boolean>,
    val isLoadingFlow: StateFlow<Boolean>,
    val isOfflineModeFlow: StateFlow<Boolean>,
    val isOfflineToggleLockedFlow: StateFlow<Boolean>,
    val selectedDiceSkinFlow: StateFlow<String>,
    val selectedDiceHatFlow: StateFlow<String>,
    val publicGamesFlow: StateFlow<List<PublicGameSummary>>,
    val publicGamesLoadingFlow: StateFlow<Boolean>,
    val publicGamesErrorFlow: StateFlow<String?>,
    val publicJoinErrorFlow: StateFlow<String?>,
    val publicGameBrowserVisibleFlow: StateFlow<Boolean>,
    val practiceOfferVisibleFlow: StateFlow<Boolean>,
    val onUpdateUserName: (String) -> Unit,
    val onUpdateGameCode: (String) -> Unit,
    val onCreateGame: () -> Unit,
    val onJoinGame: () -> Unit,
    val onQuickPlay: () -> Unit,
    val onDismissPracticeOffer: () -> Unit,
    val onShowPublicGames: () -> Unit,
    val onRefreshPublicGames: () -> Unit,
    val onHidePublicGames: () -> Unit,
    val onJoinPublicGame: (String) -> Unit,
    val onToggleOfflineMode: (Boolean) -> Unit,
    val onDiceSkinSelected: (String) -> Unit,
    val onDiceHatSelected: (String) -> Unit,
    // Whether the start screen is showing; invite links wait while a game is open on top of it.
    val onScreenVisibilityChanged: (Boolean) -> Unit,
)
